import { QuoteBand } from '@/components/ui/QuoteBand'

export const CoursesTestimonial = () => (
  <QuoteBand
    quote="Meeting Kandake and participating in her herbal courses has empowered me to reconnect with my spirit, mind and body. Her teaching through ancient knowledge, visuals and storytelling is truly life changing."
    author="Sandra Salazar"
    role="Course Participant"
  />
)
